var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('upload-statutory-modal',_vm._g({ref:"uploadDocumentModal",attrs:{"data-edit":_vm.dataEdit,"source-id":_vm.dataEdit.sourceId,"documents-list":_vm.documentsList,"documents-headers":_vm.documentsHeaders}},_vm.$listeners))}
var staticRenderFns = []

export { render, staticRenderFns }